const router = [
  {
    path: '/auth/authentication',
    name: 'Authentication',
    component: () => import('@/views/auth/Authentication.vue'),
    meta: {
      title: '实名认证',
      checkToken: true
    }
  }
];
export default router;
